import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Invoice, InvoiceUpdatePaymentDate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateInvoicePaymentDate(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  InvoiceUpdatePaymentDate
> {
  const queryClient = useQueryClient();

  const updateInvoicePaymentDate = (payload: InvoiceUpdatePaymentDate): Promise<AxiosResponse<Invoice>> => {
    return client.put(`invoices/${payload?.invoiceId}/update-payment-date/`, payload);
  };

  return useMutation(updateInvoicePaymentDate, {
    // invalidate, not remove: this is an update, and the drawer keeps reading the invoice after
    // it. The revenue keys come with it because the payment date is the column every one of
    // these reports groups on, so a correction moves the invoice between periods.
    onSuccess: () => {
      queryClient.invalidateQueries(['invoices']);
      queryClient.invalidateQueries('total-revenue');
      queryClient.invalidateQueries('upcoming-revenue');
      queryClient.invalidateQueries('package-revenue');
      queryClient.invalidateQueries('package-category-revenue');
    },
  });
}
